import { Box } from '@mui/material';
import { formatNumber, getWithLocale } from '../../utils/utils';
import {
  HomeWorkOutlined,
  FormatListNumberedOutlined,
  BedOutlined,
  WcOutlined,
  WeekendOutlined,
  KitchenOutlined,
  VisibilityOutlined,
  Explore,
  CheckCircleOutline,
  LocalParkingOutlined,
  Key,
  Apartment,
  SquareFootOutlined,
  GridViewRounded,
  Straighten,
  AspectRatio,
  EventAvailableOutlined,
	AccountBalanceOutlined,
	CleaningServicesOutlined,
	ApartmentOutlined,
	LocationCityOutlined,
	GridViewOutlined,
	HistoryEduOutlined,
  DashboardOutlined,
} from '@mui/icons-material';
import { InfoGrid, InfoRow, MainInfoRow } from '../propertydetailSection/PropertyInfo';
import { useTranslation } from 'next-i18next';

const iconSize = { fontSize: { xs: 24, sm: 32 } };

const iconMap = {
  'land-type': <DashboardOutlined sx={iconSize} />,
  type: <HomeWorkOutlined sx={iconSize} />,
  'floor-unit': <FormatListNumberedOutlined sx={iconSize} />,
  bedroom: <BedOutlined sx={iconSize} />,
  unit: <BedOutlined sx={iconSize} />,
  bathroom: <WcOutlined sx={iconSize} />,
  livingroom: <WeekendOutlined sx={iconSize} />,
  kitchenroom: <KitchenOutlined sx={iconSize} />,
  balcony: <HomeWorkOutlined sx={iconSize} />,
  View: <VisibilityOutlined sx={iconSize} />,
  Facing: <Explore sx={iconSize} />,
  storageroom: <HomeWorkOutlined sx={iconSize} />,
  completed: <CheckCircleOutline sx={iconSize} />,
  Parking: <LocalParkingOutlined sx={iconSize} />,
  property_id: <Key sx={iconSize} />,
  'property-type': <HomeWorkOutlined sx={iconSize} />,
  'building-form': <Apartment sx={iconSize} />,
  'floor-count': <FormatListNumberedOutlined sx={iconSize} />,
  'building-count': <Apartment sx={iconSize} />,
  area: <SquareFootOutlined sx={iconSize} />,
  'land-size': <GridViewRounded sx={iconSize} />,
  Size: <GridViewRounded sx={iconSize} />,
  'square meter': <GridViewRounded sx={iconSize} />,
  'Land Area': <GridViewRounded sx={iconSize} />,
  'car-unit': <LocalParkingOutlined sx={iconSize} />,
  Frontage: <Straighten sx={iconSize} />,
  view: <VisibilityOutlined sx={iconSize} />,
  facing: <Explore sx={iconSize} />,
  Depth: <AspectRatio sx={iconSize} />,
  'property-code': <Key sx={iconSize} />,
	'Quota': <AccountBalanceOutlined sx={iconSize} />,
	maidroom: <CleaningServicesOutlined sx={iconSize} />,
	'number-of-floor': <ApartmentOutlined sx={iconSize} />,
  'No. of Building': <LocationCityOutlined sx={iconSize} />,
  'hotel-number-of-unit': <GridViewOutlined sx={iconSize} />,
  'Age of Building': <HistoryEduOutlined sx={iconSize} />,
};

const getLandSize = (data, t) => {
  const landRai = data?.Land_Rai ? `${data?.Land_Rai || 0} ${t('rai')} ` : '';
  const landNga = data?.Land_Nga ? `${data?.Land_Nga || 0} ${t('ngan')} ` : '';
  const landSqw = data?.Land_Sqw ? `${data?.Land_Sqw || 0} ${t('square wa')} ` : '';
  return (landRai + landNga + landSqw) || '-';
};

const getDetailList = (type, data, t, locale) => {
  const getName = (obj) => getWithLocale(obj, 'name', locale) || '-';
  const format = (val) => Number(val) > 0 ? formatNumber(val) : '-';

  switch (type) {
		case 'Land':
      return [
				{ key: 'land-type', value: getWithLocale(data, 'category_Name', locale) },
        {
					key: 'Land Area',
          value: `${getLandSize(data, t)}`,
        },
        { key: 'Frontage', value: format(data?.Frontage), unit: t('meter') },
        { key: 'Depth', value: format(data?.Depth), unit: t('meter') },
				{ key: 'property_id', value: data?.property_Code },
      ];
			
    case 'Condominium':
      return [
        { key: 'bedroom', value: format(data?.Bedroom) },
        { key: 'bathroom', value: format(data?.Bathroom) },
        { key: 'square meter', value: format(data?.property_Size) },
        { key: 'livingroom', value: format(data?.Living_Room) },
        { key: 'car-unit', value: format(data?.property_Parking) },
        { key: 'property_id', value: data?.property_Code },
        { key: 'type', value: getWithLocale(data, 'category_Name', locale) },
        { key: 'floor-unit', value: format(data?.located_on_floor) , unit: t('floor-unit') },
        { key: 'kitchenroom', value: format(data?.Kitchen), unit: t('room') },
        { key: 'storageroom', value: format(data?.Storage_room), unit: t('room') },
        { key: 'balcony', value: format(data?.Balcony), unit: t('room') },
        { key: 'Facing', value: getName(data?.Direction) },
        { key: 'View', value: getName(data?.View) },
        { key: 'Quota', value: getName(data?.property_quota) },
      ];

    case 'Commercail':
      return [
				{ key: 'bedroom', value: format(data?.Bedroom) },
        { key: 'bathroom', value: format(data?.Bathroom) },
        { key: 'square meter', value: format(data?.property_Size) },
				{ key: 'Age of Building', value: data?.ageOfBuilding },
				{ key: 'property_id', value: data?.property_Code },
        { key: 'type', value: getWithLocale(data, 'category_Name', locale) },
        {
          key: 'Land Area',
          value: data.Land_Size ? `${formatNumber(data.Land_Size)}` : '-',
					unit: t('square wa'),
        },
				{ key: 'Frontage', value: format(data?.Frontage), unit: t('meter') },
        { key: 'Depth', value: format(data?.Depth), unit: t('meter') },
        { key: 'Facing', value: getName(data?.Direction) },
        { key: 'View', value: getName(data?.View) },
      ];

    case 'House':
		case 'Shop':
		case 'Office':
			return [
				{ key: 'bedroom', value: format(data?.Bedroom) },
        { key: 'bathroom', value: format(data?.Bathroom) },
        { key: 'square meter', value: format(data?.property_Size) },
				{ key: 'livingroom', value: format(data?.Living_Room) },
				{ key: 'car-unit', value: format(data?.property_Parking) },
        { key: 'property_id', value: data?.property_Code },
        { key: 'type', value: getWithLocale(data, 'category_Name', locale) },
        {
          key: 'Land Area',
          value: data.Land_Size ? `${formatNumber(data.Land_Size)}` : '-',
					unit: t('square wa'),
        },
        { key: 'kitchenroom', value: format(data?.Kitchen), unit: t('room') },
        { key: 'storageroom', value: format(data?.Storage_room), unit: t('room') },
        { key: 'balcony', value: format(data?.Balcony), unit: t('room') },
        { key: 'Frontage', value: format(data?.Frontage), unit: t('meter') },
        { key: 'Depth', value: format(data?.Depth), unit: t('meter') },
        { key: 'Facing', value: getName(data?.Direction) },
        { key: 'View', value: getName(data?.View) },
				{ key: 'maidroom', value: format(data?.Maidroom), unit: t('room') },
      ];

		case 'Apartment':
		case 'Hotel':
		case 'Warehouse':
			return [
				{ key: 'unit', value: format(data?.Bedroom) },
        { key: 'bathroom', value: format(data?.Bathroom) },
        { key: 'square meter', value: format(data?.property_Size) },
				{ key: 'livingroom', value: format(data?.Living_Room) },
				{ key: 'car-unit', value: format(data?.property_Parking) },
        { key: 'property_id', value: data?.property_Code },
        { key: 'type', value: getWithLocale(data, 'category_Name', locale) },
        {
          key: 'Land Area',
          value: data.Land_Size ? `${formatNumber(data.Land_Size)}` : '-',
					unit: t('square wa'),
        },
        { key: 'kitchenroom', value: format(data?.Kitchen), unit: t('room') },
        { key: 'storageroom', value: format(data?.Storage_room), unit: t('room') },
        { key: 'balcony', value: format(data?.Balcony), unit: t('room') },
        { key: 'Frontage', value: format(data?.Frontage), unit: t('meter') },
        { key: 'Depth', value: format(data?.Depth), unit: t('meter') },
        { key: 'Facing', value: getName(data?.Direction) },
        { key: 'View', value: getName(data?.View) },
				{ key: 'maidroom', value: format(data?.Maidroom), unit: t('room') },
				{ key: 'number-of-floor', value: format(data?.property_Floor), unit: t('floor-unit') },
				{ key: 'No. of Building', value: format(data?.Buildings) },
				{ key: 'hotel-number-of-unit', value: format(data?.Unit), unit: t('unit') },
				{ key: 'Age of Building', value: format(data?.ageOfBuilding) },
      ];

    default:
      return [];
  }
};

const RenderDetail = ({ data, locale }) => {
  const { t } = useTranslation();
  const items = getDetailList(data?.type, data, t, locale);
  const topItems = items.slice(0, 5);
  const otherItems = items.slice(5);

  return (
    <Box>
      {/* MainInfoRow – แสดง 5 รายการแรก */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          my: 4,
        }}
      >
        {topItems.map((item, index) => {
          const icon = iconMap[item.key];
          const label = t(item.key);
          return (
            <Box
              key={index}
              sx={{
								mb: 2,
                flex: '1 1 33.3333%',
								maxWidth: '33.3333%',
                '@media (min-width: 800px)': {
                  flex: '1 1 20%',
                  maxWidth: '20%',
                },
              }}
            >
              <MainInfoRow icon={icon} label={label} value={item.value} unit={item.unit} />
            </Box>
          );
        })}
      </Box>

      {/* InfoRow – รายการอื่น ๆ */}
      <InfoGrid>
        {otherItems.map((item, index) => {
          const icon = iconMap[item.key];
          const label = t(item.key);
          return (
            <Box key={index}>
              <InfoRow icon={icon} label={label} value={item.value} unit={item.unit} />
            </Box>
          );
        })}
      </InfoGrid>
    </Box>
  );
};

export default RenderDetail;
